// src/services/categoryService.ts
import { CategoryWithSubcategories } from '../types/category';
import { Category, getBranchCategories, insertCategory, supabase } from '../utils/supabaseClient';

/**
 * Get all categories for a restaurant
 */
export const getCategoriesByBranch = async (branch_id: string): Promise<Category[]> => {
  try {

    const { data, error } = await getBranchCategories(branch_id);
    if (error)
      throw new Error(error.message)

    return data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

export const getCategoryHierarchy = async (branch_id: string): Promise<CategoryWithSubcategories[]> => {
  try {
    const allCategories = await getCategoriesByBranch(branch_id);
    const rootCategories = allCategories.filter(category => !category.parent_id);
    const hierarchy = rootCategories.map(root => buildCategoryTree(root, allCategories));

    return hierarchy;
  } catch (error) {
    console.error('Error building category hierarchy:', error);
    throw error;
  }
};

/**
 * Recursively build category tree
 */
const buildCategoryTree = (
  rootCategory: Category,
  allCategories: Category[]
): CategoryWithSubcategories => {
  const children = allCategories
    .filter(category => category.parent_id === rootCategory.id)
    .map(child => buildCategoryTree(child, allCategories));

  return {
    ...rootCategory,
    children
  };
};

/**
 * Get category by ID
 */
export const getCategoryById = async (categoryId: string): Promise<Category | null> => {
  try {
    // const category = mockCategories.find(category => category.id === categoryId);
    // return category || null;

    const { data, error } = await supabase.from('categories').select('*').eq('id', categoryId).single();
    if (error) throw new Error(error.message);
    return data;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};
/**
 * Get all child category IDs recursively
 */
const getAllChildCategoryIds = (categoryId: string, categories: Category[]): string[] => {
  const directChildren = categories
    .filter(category => category.parent_id === categoryId)
    .map(child => child.id);

  const allChildren = [...directChildren];

  // Recursively get children of each direct child
  directChildren.forEach(childId => {
    const childrenOfChild = getAllChildCategoryIds(childId!, categories);
    allChildren.push(...childrenOfChild);
  });

  return allChildren;
};
